<template>
    <div class="carousel-wrap" style="background-image: url('/static/slider1.png')">
        <div class="container">
            <div class="row">
                <div class="col">
                    <h3 class="carousel-wrap-title">{{$t("public.reviews.title")}}</h3>
                    <span class="carousel-wrap-subtitle">{{$t("public.reviews.subtitle")}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-carousel
                        id="carouselExampleIndicators2"
                        class="carousel slide"
                        controls
                        indicators
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd">
                        <b-carousel-slide class="carousel-item active">
                            <h2 class="carousel-item-title" v-html="$t('public.reviews.slider[0].text')"></h2>
                            <span class="carousel-item-text">{{$t("public.reviews.slider[0].name")}}</span>
                            <!-- TODO: Waiting to video -->
                            <a href="#" class="carousel-item-link d-none">
                                <i class="icon-youtube-play"></i>
                                peržiūrėti
                            </a>
                        </b-carousel-slide>
                        <b-carousel-slide class="carousel-item active">
                            <h2 class="carousel-item-title" v-html="$t('public.reviews.slider[1].text')"></h2>
                            <span class="carousel-item-text">{{$t("public.reviews.slider[1].name")}}</span>
                            <!-- TODO: Waiting to video -->
                            <a href="#" class="carousel-item-link d-none">
                                <i class="icon-youtube-play"></i>
                                peržiūrėti
                            </a>
                        </b-carousel-slide>
                        <b-carousel-slide class="carousel-item active">
                            <h2 class="carousel-item-title" v-html="$t('public.reviews.slider[2].text')"></h2>
                            <span class="carousel-item-text">{{$t("public.reviews.slider[2].name")}}</span>
                            <!-- TODO: Waiting to video -->
                            <a href="#" class="carousel-item-link d-none">
                                <i class="icon-youtube-play"></i>
                                peržiūrėti
                            </a>
                        </b-carousel-slide>
                        <b-carousel-slide class="carousel-item active">
                            <h2 class="carousel-item-title" v-html="$t('public.reviews.slider[3].text')"></h2>
                            <span class="carousel-item-text">{{$t("public.reviews.slider[3].name")}}</span>
                            <!-- TODO: Waiting to video -->
                            <a href="#" class="carousel-item-link d-none">
                                <i class="icon-youtube-play"></i>
                                peržiūrėti
                            </a>
                        </b-carousel-slide>
                    </b-carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PrioritiesCarousel',
        data() {
            return {
                sliding: null
            }
        },
        methods: {
            onSlideStart(slide) {
                this.sliding = true
            },
            onSlideEnd(slide) {
                this.sliding = false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/PrioritiesCarousel.vue